import { Box, Container, Flex, Text, Stack, SimpleGrid } from '@chakra-ui/react'
import { Link } from 'react-router-dom'
import BrandLogo from './BrandLogo'

const FOOTER_LINKS = [
  {
    title: 'Platform',
    links: [
      { label: 'Fiyat Hesapla', to: '/tr/yukle' },
      { label: 'Model Pazarı', to: '/tr/pazar' },
      { label: 'Hizmetler', to: '/tr/hizmetler' },
      { label: 'Baskı Firmaları', to: '/tr/firmalar' },
    ],
  },
  {
    title: 'Destek',
    links: [
      { label: 'Yardım Merkezi', to: '/tr/yardim' },
      { label: 'Blog', to: '/tr/blog' },
    ],
  },
  {
    title: 'Yasal',
    links: [
      { label: 'Gizlilik Politikası', to: '/tr/gizlilik' },
      { label: 'Kullanım Koşulları', to: '/tr/kullanim-kosullari' },
    ],
  },
]

export default function Footer() {
  return (
    <Box
      as="footer"
      bg="#050505"
      borderTop="1px solid rgba(255,255,255,0.07)"
      py={{ base: 10, md: 14 }}
      px={{ base: 4, md: 8 }}
    >
      <Container maxW="1200px">
        <SimpleGrid columns={{ base: 1, sm: 2, md: 4 }} gap={8} mb={10}>
          {/* Brand column */}
          <Stack gap={4}>
            <BrandLogo size={40} showWordmark wordmarkSize="md" />
            <Text color="rgba(255,255,255,0.4)" fontSize="sm" lineHeight="1.6">
              Türkiye'nin 3D baskı platformu. Modelini yükle, fiyat al, firman seç.
            </Text>
          </Stack>

          {/* Link columns */}
          {FOOTER_LINKS.map((col) => (
            <Stack key={col.title} gap={3}>
              <Text color="rgba(255,255,255,0.5)" fontSize="xs" fontWeight="600" textTransform="uppercase" letterSpacing="wider">
                {col.title}
              </Text>
              {col.links.map((link) => (
                <Link key={link.to} to={link.to} style={{ textDecoration: 'none' }}>
                  <Text
                    color="rgba(255,255,255,0.5)"
                    fontSize="sm"
                    _hover={{ color: 'white' }}
                    transition="color 0.15s"
                  >
                    {link.label}
                  </Text>
                </Link>
              ))}
            </Stack>
          ))}
        </SimpleGrid>

        <Flex
          justify="space-between"
          align="center"
          borderTop="1px solid rgba(255,255,255,0.06)"
          pt={6}
          flexDirection={{ base: 'column', sm: 'row' }}
          gap={2}
        >
          <Text color="rgba(255,255,255,0.25)" fontSize="xs">
            © {new Date().getFullYear()} 3d-yazdir.com — Tüm hakları saklıdır.
          </Text>
          <Text color="rgba(255,255,255,0.25)" fontSize="xs">
            Türkiye
          </Text>
        </Flex>
      </Container>
    </Box>
  )
}
